import { render } from "./Carousel-index.vue?vue&type=template&id=efe20884&scoped=true"
import script from "./Carousel-index.vue?vue&type=script&lang=js"
export * from "./Carousel-index.vue?vue&type=script&lang=js"

import "./Carousel-index.vue?vue&type=style&index=0&id=efe20884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe20884"]])

export default __exports__